import { render, staticRenderFns } from "./CaracteristicasEmergencia.vue?vue&type=template&id=6e12b939"
import script from "./CaracteristicasEmergencia.vue?vue&type=script&lang=js"
export * from "./CaracteristicasEmergencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports